import { useNavigate } from 'react-router-dom';
import { StoryErrorBlock } from '@/components/patterns/StoryErrorBlock';
import { FLITZI_IMAGE_SRC } from '@/features/story/error-variants';
import { STRINGS } from '@/strings/strings';

/**
 * 404 fallback route — catches all unmatched paths inside AppShell
 * (Batch 12 Sub-phase C). Briefing Kap. 11 line 1550-1560 — chrome
 * (TopBar + BottomNav) stays visible because the user is logged-in
 * and should be able to navigate away.
 *
 * Reuses `StoryErrorBlock` (Sub-phase B) + `FLITZI_IMAGE_SRC`
 * constant. Variant builder is inlined here per Sebastian Gate-1
 * 2026-04-27 — single-use, no value in promoting to a separate
 * feature folder.
 *
 * Asset is the tool-Flitzi (briefing prescribes question-mark
 * variant — see PWA Offen tracker #57 for the asset swap).
 *
 * `<Route path="*" />` placement: last route inside the
 * `<Route element={<AppShell />}>` group in `App.tsx`. Unmatched
 * paths under `/auth/*` or `/onboarding/*` currently fall through
 * to a blank render — outer-level fallback tracked as PWA Offen #59.
 */
export function NotFoundRoute() {
  const navigate = useNavigate();
  const S = STRINGS.notFound;
  return (
    <StoryErrorBlock
      illustrationSrc={FLITZI_IMAGE_SRC}
      illustrationAlt={S.illustrationAlt}
      title={S.title}
      body={S.body}
      primaryCta={{ label: S.ctaPrimary, onClick: () => navigate('/') }}
      secondaryCta={{ label: S.ctaSecondary, onClick: () => navigate('/library') }}
      testId="not-found-block"
    />
  );
}
